module.exports = __webpack_public_path__ + "static/photo13-08472b6de8102276d2283cca8e960dc1.png";